import React from 'react';

import {StepViewFieldProps} from '../commonprops';
import {StepViewGenericChoicesField} from '../generic-choices-fields';

export const StepViewRadiobuttonField = ({field}: StepViewFieldProps) => (
  <StepViewGenericChoicesField inputType="radio" field={field} />
);
